import React, {forwardRef, useImperativeHandle} from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon} from 'fmlx-common-ui';
import {connect, useSelector} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getWizardViewDataSelector} from 'stores/selectors/wizardSelectors';

import withIntl from '../../../lib/withIntl';

import './ReportSetupWizard.scss';
import {SetupWizardStep} from '../../../constants/SetupWizardEnum';
import {showConfirmationSkippedStep} from '../../../stores/business/setupWizardBusiness/setupWizardBusiness';

function ReportSetupWizard({intl, data}) {
  return (
    <div className="setup-wizard-report">
      <div className="setup-wizard-report__icon">
        <img className="icon" alt="./svg/preparation-wizard/logo.svg" src="./svg/preparation-wizard/logo.svg" />
      </div>
      <div className="setup-wizard-report__wrapper">
        <div className="setup-wizard-report__header">
          <span>{intl.formatMessage({id: 'setupWizard.step.report.title'})}</span>
        </div>
        <div className="setup-wizard-report__content">
          {data.map((e) =>
            e.stepName !== SetupWizardStep.WELCOME_SCREEN &&
            e.stepName !== SetupWizardStep.REPORT &&
            e.stepName !== SetupWizardStep.FINISH_SCREEN ? (
              <div className="setup-wizard-report__content__item">
                <span className={`item__number ${e.isStepProcessed ? 'success' : 'skipped'}`}>{e.step}</span>
                <div className={`item__text ${e.isStepProcessed ? 'success' : 'skipped'}`}>
                  {intl.formatMessage({id: `setupWizard.stepper.label.${e.stepName}`})}
                </div>
                <div className="item__status">
                  <FmlxIcon
                    name={e.isStepProcessed ? 'CheckboxDefault' : 'Cancel'}
                    customColor={e.isStepProcessed ? '#3F9243' : '#B4B4B4'}
                    size="sm"
                  />
                  <span className={e.isStepProcessed ? 'success' : 'skipped'}>
                    {e.isStepProcessed ? 'Success' : 'Skipped'}
                  </span>
                </div>
              </div>
            ) : (
              // eslint-disable-next-line react/jsx-no-useless-fragment
              <></>
            ),
          )}
        </div>
      </div>
    </div>
  );
}

ReportSetupWizard.propTypes = {
  intl: PropTypes.any.isRequired,
  data: PropTypes.array.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setupWizardBusinessShowConfirmationSkippedStep: bindActionCreators(showConfirmationSkippedStep, dispatch),
});

const WrappedReportSetupWizard = forwardRef(({setupWizardBusinessShowConfirmationSkippedStep, ...props}, ref) => {
  const allWizardData = useSelector(getWizardViewDataSelector);

  const onContinue = () =>
    new Promise((resolve) => {
      const callback = (changeStep) => {
        resolve({isChangeStep: changeStep, isCheckContinueButtonAccess: changeStep});
      };
      setupWizardBusinessShowConfirmationSkippedStep(callback);
    });

  useImperativeHandle(ref, () => ({
    onContinue,
  }));

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ReportSetupWizard {...props} data={Object.values(allWizardData)} />;
});

WrappedReportSetupWizard.propTypes = {
  setupWizardBusinessShowConfirmationSkippedStep: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps, null, {forwardRef: true})(withIntl(WrappedReportSetupWizard));
